"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var Scale = /*#__PURE__*/function () {
  function Scale() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    (0, _classCallCheck2["default"])(this, Scale);
    (0, _defineProperty2["default"])(this, "_x", void 0);
    (0, _defineProperty2["default"])(this, "_y", void 0);
    this.x = x;
    this.y = y;
  }

  (0, _createClass2["default"])(Scale, [{
    key: "copy",
    value: function copy() {
      return new Scale(this.x, this.y);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        x: this.x,
        y: this.y
      };
    }
    /**
     * Checks if object is an instance of Scale
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      if ((0, _isNumber["default"])(value)) {
        this._x = value;
      }
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      if ((0, _isNumber["default"])(value)) {
        this._y = value;
      }
    }
  }], [{
    key: "isScale",
    value: function isScale(inputObject) {
      return inputObject instanceof Scale;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if ((0, _isEmpty["default"])(json)) {
        return null;
      }

      return new Scale(json.x, json.y);
    }
  }]);
  return Scale;
}();

exports["default"] = Scale;